import { render, staticRenderFns } from "./sensorDanLingScreen.vue?vue&type=template&id=4e36a53c&"
import script from "./sensorDanLingScreen.vue?vue&type=script&lang=js&"
export * from "./sensorDanLingScreen.vue?vue&type=script&lang=js&"
import style0 from "./sensorDanLingScreen.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports